// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"349":"8d875d99","453":"902bc8d1"}[chunkId] + ".chunk.js";
};